/**
 *
 * @module loggingClientConfiguration
 *
 */

import ServiceClientConfiguration from '../services/configuration/serviceClientConfiguration';

/**
 *
 * @class LoggingClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc A model containing the LoggingClient's configuration settings.
 *
 */
export default class LoggingClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/logging/loggingClientConfiguration.js